// Core
import { toast, TypeOptions } from "react-toastify";

type UseToastType = {
  type?: string;
  message: string;
};

export const showToast = (data: UseToastType) => {
  toast(data.message, {
    type: (data.type as TypeOptions) ?? "default",
  });
};
